<template>
  <div class="mb-3">
    <div class="dropbox mb-3">
      <input
        ref="uploader"
        :name="uploadFieldName"
        accept="image/*"
        class="input-file"
        multiple
        type="file"
        @change="filesChange"
      />
      <p v-if="isInitial">
        Arrastra tus archivos aquí<br />
        o has click para seleccionarlo
      </p>
      <p v-if="isFailed">
        La carga del último archivo ha fallado! <br />
        <small>{{ fileCount }} archivos cargados ...</small>
      </p>
      <p v-if="isSaving">Cargando archivos ...</p>
      <p v-if="isSuccess">
        {{ fileCount }}&nbsp;<span v-if="fileCount === 1">archivo cargado</span
        ><span v-else>archivos cargados</span> ...
      </p>
    </div>

    <ul
      v-for="(image, index) in images"
      :key="image.id"
      ref="preview"
      class="list-group list-group-lg list-group-flush"
    >
      <li class="list-group-item px-0">
        <div class="row align-items-center">
          <div class="col-auto">
            <div class="avatar">
              <img :src="image.dataUrl" class="avatar-img rounded" />
            </div>
          </div>
          <div class="col ml--3 text-center">
            <h4 class="mb-1">{{ image.file.name }}</h4>
            <p class="small text-muted mb-0">{{ fileSize(image.file.size) }} MB</p>
          </div>
          <div class="col-auto">
            <button title="Eliminar" class="btn btn-danger btn-sm" @click="removeFile(index)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="row mt-2 mx-5">
          <div class="col">
            <el-input v-model="image.description" name="description" placeholder="Agregue descripción para la imagen">
            </el-input>
          </div>
        </div>
      </li>
    </ul>

    <div v-if="fileCount" class="row mt-3 py-3">
      <div class="col-sm-12">
        <button class="btn btn-success btn-fill float-right" @click="save">Guardar Imagenes</button>
      </div>
    </div>
  </div>
</template>

<script>
const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: 'ImageUploader',
  props: {
    images: {
      type: Array,
      default: () => [],
    },

    maxAllowedQuantity: {
      type: Number,
      default: null,
    },

    pictureQuantity: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      uploadFieldName: 'images',
      uploadError: null,
      current: null,
      currentStatus: null,
    };
  },

  computed: {
    isInitial() {
      return this.fileCount === 0 && this.currentStatus === STATUS_INITIAL;
    },

    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },

    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },

    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },

    fileCount() {
      return this.images.length;
    },
  },

  watch: {
    images: {
      handler() {
        if (this.fileCount === 0) {
          this.resetStats();
        }
      },
    },
  },

  mounted() {
    this.reset();
  },

  methods: {
    save() {
      this.$emit('upload');
    },

    reset() {
      // reset form to initial state
      this.$emit('reset');
      this.resetStats();
    },

    resetStats() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
      this.$refs.uploader.value = null;
    },

    fileSize(size) {
      return Number.parseFloat(size / Math.pow(1024, 2))
        .toPrecision(2)
        .toString();
    },

    filesChange(event) {
      const fileList = event.target.files;

      if (!fileList.length) {
        return;
      }

      if (this.fileCount + fileList.length + this.pictureQuantity > this.maxAllowedQuantity) {
        this.$emit('alert:count');

        return;
      }

      Array.from(fileList).map((file) => {
        this.currentStatus = STATUS_SAVING;

        this.getImage(file);
      });
    },

    getImage(file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader();

        fReader.onload = () => {
          this.addFile(file, fReader.result);
          this.currentStatus = STATUS_SUCCESS;
          resolve();
        };

        fReader.onerror = () => {
          this.currentStatus = STATUS_FAILED;
          reject();
        };

        fReader.readAsDataURL(file);
      });
    },

    addFile(file, dataUrl) {
      this.current = {
        file: file,
        dataUrl: dataUrl,
        description: '',
      };

      this.$emit('add:image', this.current);
    },

    removeFile(index) {
      if (index !== -1) {
        this.$emit('remove:image', index);
      }
    },
  },
};
</script>

<style scoped>
.dropbox {
  border: 1px dashed #dee2e6;
  border-radius: 0.375rem;
  text-align: center;
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  color: #8898aa;
  padding: 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  border-color: #8898aa;
  color: #525f7f; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
